import React from "react";

const Advisors = () => {
  return (
    <div className="container">
      <div className="td_height_60 td_height_lg_40" />

      <h2 className="td_section_title td_fs_32 mb-4 text-center">
        World-Class Academic Standards & Advisors
      </h2>

      <h2 className="td_section_title td_fs_24 mb-2">
        National Senior Advisors
      </h2>

      <p className="td_fs_18">
        <ul className="advisors-list">
          <li className="advisors-list-item">Dr. Poorna Kanta Adhikary</li>
          <li className="advisors-list-item">Dr. Krishna Kumar Pandey</li>
          <li className="advisors-list-item">Dr. Bishnu Dev Pant</li>
          <li className="advisors-list-item">Mr. Kishore Thapa</li>
        </ul>
      </p>

      <div className="td_height_20 td_height_lg_30" />

      <h2 className="td_section_title td_fs_24 mb-2">
        International Expert Advisory Committee (IEAC)
      </h2>
      <p className="td_fs_18">
        UNepal works in active partnership with the University of Nepal
        International Expert Advisory Committee (IEAC), which provides academic
        and technical advice for the advancement of UNepal's mission.
      </p>

      <table className="advisors-table"> 
        <thead>
          <tr>
            <th className="advisors-table-header"></th>
            <th className="advisors-table-header">Position</th>
            <th className="advisors-table-header">Institution</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Robert F. Woollard (Chair)
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor Emeritus
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              University of British Columbia, Canada
            </td>
          </tr>
          <tr className="advisors-row-tint">
            <td className="advisors-table-cell advisors-cell-name">
              Richard Born
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor Emeritus
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              Harvard Medical School, USA
            </td>
          </tr>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Klaudia Brix
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              Constructor University, Germany
            </td>
          </tr>
          <tr className="advisors-row-tint">
            <td className="advisors-table-cell advisors-cell-name">
              Ann Buller
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              President Emeritus
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              Centennial College, Canada
            </td>
          </tr>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Peter Keller
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor Emeritus
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              Simon Fraser University, Canada
            </td>
          </tr>
          <tr className="advisors-row-tint">
            <td className="advisors-table-cell advisors-cell-name">
              Lauren G. Leve
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Associate Professor
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              University of North Carolina, USA
            </td>
          </tr>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Kenneth D. Lukowiak
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              University of Calgary, Canada
            </td>
          </tr>
          <tr className="advisors-row-tint">
            <td className="advisors-table-cell advisors-cell-name">
              Greg Moran
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor and Provost Emeritus
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              University of Western Ontario, Canada
            </td>
          </tr>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Uma Pradhan
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Associate Professor
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              University College London, UK
            </td>
          </tr>
          <tr className="advisors-row-tint">
            <td className="advisors-table-cell advisors-cell-name">
              Carsten Schröder
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor and Vice President
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              University of Applied Sciences, Germany
            </td>
          </tr>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Joachim Schultz-Granberg
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              University of Applied Sciences, Germany
            </td>
          </tr>
          <tr className="advisors-row-tint">
            <td className="advisors-table-cell advisors-cell-name">
              Megan Adamson Sijapati
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Associate Professor
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              Gettysburg College, USA
            </td>
          </tr>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Henrik Sjovall
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor Emeritus
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              University of Gothenburg, Sweden
            </td>
          </tr>
          <tr className="advisors-row-tint">
            <td className="advisors-table-cell advisors-cell-name">
              Anne Urbancic
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Assoc. Prof. (Teaching Stream), Emerita Retired Fellow
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              Victoria College, University of Toronto, Canada
            </td>
          </tr>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Paul Worley
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor Emeritus
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              Flinders University, Australia
            </td>
          </tr>
        </tbody>
      </table>

      <div className="td_height_30 td_height_lg_30" />

      <h2 className="td_section_title td_fs_24 mb-2">
        International Senior Advisors
      </h2>
      <table className="advisors-table">
        <tbody>
          <tr>
            <td className="advisors-table-cell advisors-cell-name">
              Tae Yong Jung
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              Yonsei University, South Korea
            </td>
          </tr>
          <tr className="advisors-row-tint">
            <td className="advisors-table-cell advisors-cell-name">
              Morichi Shigeru
            </td>
            <td className="advisors-table-cell advisors-cell-role">
              Professor Emeritus
            </td>
            <td className="advisors-table-cell advisors-cell-org">
              The University of Tokyo, Japan
            </td>
          </tr>
        </tbody>
      </table>
      <div className="td_height_30 td_height_lg_40" />
    </div>
  );
};

export default Advisors;
